import { gql } from "@apollo/client/core";

export const GET_METADATA_RETRIEVALS = gql`
  query GetRetrievals($orgId: ID!) {
    metadataRetrievals(organizationId: $orgId) {
      id
      status
      progressPercentage
    }
  }
`;

export const START_METADATA_RETRIEVAL = gql`
  mutation StartRetrieval($input: StartRetrievalInput!) {
    startMetadataRetrieval(input: $input) {
      id
      status
      currentPhase
    }
  }
`;
